<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="600px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
            <span class="px-3">{{ $t('Cash & Cashier Balance') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <v-layout row wrap pa-2 v-if="viewInfo.cashier">
          <v-flex xs12 pa-2>
            <h3>{{ $t('Cashier Balance') }}</h3>
          </v-flex>
          <v-flex xs11 mb-3>
            <v-divider />
          </v-flex>

          <v-flex xs6 pb-3>
            <div class="caption no-select">{{ $t('Begin (IQD)') }}</div>
            <strong>{{ viewInfo.cashier.begin_iq | currency }}</strong>
          </v-flex>

          <v-flex xs6 pb-3>
            <div class="caption no-select">{{ $t('Begin (USD)') }}</div>
            <strong>{{ viewInfo.cashier.begin_us | currency }}</strong>
          </v-flex>

          <v-flex xs6 pb-3>
            <div class="caption no-select">{{ $t('Balance (IQD)') }}</div>
            <strong>{{ viewInfo.cashier.amount_iq | currency }}</strong>
          </v-flex>

          <v-flex xs6 pb-3>
            <div class="caption no-select">{{ $t('Balance (USD)') }}</div>
            <strong>{{ viewInfo.cashier.amount_us | currency }}</strong>
          </v-flex>
        </v-layout>

        <v-layout row wrap pa-2 v-if="viewInfo.cash_balance">
          <v-flex xs12 pa-2>
            <h3>{{ $t('Cash Balance') }}</h3>
          </v-flex>
          <v-flex xs11 mb-3>
            <v-divider />
          </v-flex>

          <v-flex xs6 pb-3>
            <div class="caption no-select">{{ $t('Balance (IQD)') }}</div>
            <strong>{{ viewInfo.cash_balance.amount_iq | currency }}</strong>
          </v-flex>

          <v-flex xs6 pb-3>
            <div class="caption no-select">{{ $t('Balance (USD)') }}</div>
            <strong>{{ viewInfo.cash_balance.amount_us | currency }}</strong>
          </v-flex>

          <v-flex xs6 pb-3>
            <div class="caption no-select">{{ $t('Total Share Number') }}</div>
            <strong>{{ viewInfo.cash_balance.total_share_number | currency }}</strong>
          </v-flex>

          <v-flex xs6 pb-3>
            <div class="caption no-select">{{ $t('Share Price') }}</div>
            <v-edit-dialog
              v-if="hasPermissions(['cash_balance_update'])"
              :return-value.sync="viewInfo.cash_balance.share_price"
              @close="close"
              lazy
            >
              <strong>{{ viewInfo.cash_balance.share_price | currency }}</strong>
              <v-tooltip :left="!$vuetify.rtl" :right="$vuetify.rtl">
                <v-icon style="margin-left: 20px" size="22" color="primary" slot="activator">edit</v-icon>
                <span>{{ $t(`Edit Share Price`) }}</span>
              </v-tooltip>
              <template v-slot:input>
                <v-text-field
                  v-model="viewInfo.cash_balance.share_price"
                  :label="$t('Share Price')"
                  data-vv-name="Share Price"
                  :error="errors.has('Share Price')"
                  append-outer-icon="save"
                  @keyup.enter="validateBeforeSubmit()"
                  v-validate="'required|numeric'"
                  @click:append-outer="() => validateBeforeSubmit()"
                ></v-text-field>
              </template>
            </v-edit-dialog>
            <strong v-else>{{ viewInfo.cash_balance.share_price | currency }}</strong>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Close') }}</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'view-component',

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency
    }
  },

  computed: {
    ...mapGetters({
      viewInfo: 'dashboard/getCashBalance'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    ...mapActions({
      updateSharePrice: 'dashboard/updateSharePrice',
      fetchInfo: 'dashboard/fetchCashBalance'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    close() {
      this.fetchInfo()
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          let formData = new FormData()
          formData.append('share_price', this.viewInfo.cash_balance.share_price)
          let payload = { formData }
          this.updateSharePrice(payload).then(() => {
            this.close()
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
